import React, { useEffect, useState } from 'react'
import SideBar from '../Sidebar/SideBar';
import AccountManagerINformationApi from '../../Api/AccountManagerInformationApi';
import { Icon } from '@iconify/react/dist/iconify.js';
import Branches from '../../Api/Branches';
import AccountManager from '../../Api/AccountManager';
import SearchableDropdown from './SearchableDropdown';
import Swal from "sweetalert2";

const AccountManageInformation = () => {

    const [data, setData] = useState([]);
    const [branchData, setBranchData] = useState([]);
    const [itemId, setItemId] = useState('');
    const [accountManagerMasterData, setAccountManagerMasterData] = useState([]);
    const [inputValues, setInputValues] = useState({
        accountManagerId: '',
        branchId: '',
        active: true,
    });

    console.log("inputValues", inputValues);

    function formatIsoDate(isoDate) {
        if (typeof isoDate !== 'string' || !isoDate) {
            throw new Error("Invalid input: Please provide a valid ISO date string.");
        }

        const datePart = isoDate.substring(0, 10);
        const [year, month, day] = datePart.split('-');

        return `${day}-${month}-${year}`;
    }


    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    const handleSave = async () => {
        const response = await AccountManagerINformationApi.CreateAccountManagerInformation(inputValues)
        if (response) {
            console.log('response', response);
            fetchData()
        }
        console.log('Saved:', inputValues);
    };

    const handleUpdate = async () => {

        const response = await AccountManagerINformationApi.UpdateAccountManagerInformation(itemId, inputValues)
        if (response) {
            console.log('response', response);
            fetchData()
        }
        console.log('Updated:', inputValues);
        setItemId('');
        setInputValues({
            accountManagerId: '',
            branchId: '',
            active: true,
        })

    }

    const handleEdit = (item) => {
        console.log("item", item);
        setItemId(item.id)
        setInputValues({
            accountManagerId: item.acManagerId,
            branchId: item.branchId,
            active: item.active,
        })

        console.log(`Edit item with id ${item.id}`);
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Delete this record?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete",
            cancelButtonText: "No, keep it",
            reverseButtons: true,
            width: "340px",
        });

        if (!result.isConfirmed) return;

        const response = await AccountManagerINformationApi.DeleteAccountManagerInformation(id);
        if (response.StatusCode === 200) {
            Swal.fire({
                title: "Deleted",
                text: "Deleted Successfully.",
                icon: "success",
                width: "320px"
            });
            fetchData();
        }
    };



    const fetchData = async () => {
        const response = await AccountManagerINformationApi.GetAllAccountManagerInformation()
        if (response) {
            console.log("response", response);
            setData(response.Result)
        }
    }
    useEffect(() => {
        fetchData();
    }, []);



    const fetchBranchData = async () => {
        const response = await Branches.GetAllClients()
        if (response) {

            console.log("response", response);
            setBranchData(response.Result)
        }
    }
    useEffect(() => {
        fetchBranchData()
    }, []);

    const fetchAccountManagerMasterdata = async () => {
        const response = await AccountManager.GetAllAccountManager();
        if (response) {
            console.log("Account Manager Master Data:", response.Result);
            setAccountManagerMasterData(response.Result);
        }
    }

    useEffect(() => {
        fetchAccountManagerMasterdata()
    }, []);

    const getBranchName = (id) => {
        const branch = branchData.find(b => b.id === id);
        return branch ? branch.branchName : id; // fallback to id if not found
    };

    const getManagerName = (id) => {
        const manager = accountManagerMasterData.find(m => m.id === id);
        return manager ? manager.name : id; // fallback to id if not found
    };

    return (
        <div className='Flex-general-client-sidebar'>
            <div className='sidebar-gen-width'>
                <SideBar />
            </div>
            <div className='Main-general-Client'>
                <div className='header-general'>
                    <h2 className='general-card-title'>Account Manager Information</h2>
                </div>
                <div className="control_radius">
                    {/* <div className="company_info-text-im depart_top">Report Template Setting</div> */}
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1">
                                <div className="input-box-mok1">
                                    {/* <input className="modify_im_input mode_category1"
                                        type="text" name="accountManagerId" value={inputValues.accountManagerId} onChange={handleChange} required />
                                    <label class="modify_p_text2">Account Manager Id</label> */}
                                    <SearchableDropdown
                                        options={accountManagerMasterData}
                                        value={inputValues.accountManagerId}
                                        onChange={(id) => setInputValues({ ...inputValues, accountManagerId: id })}
                                        labelField="name"
                                        valueField="id"
                                        placeholder="Select Account Manager"
                                        required
                                    />

                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    {/* <input className="modify_im_input mode_category1" value={inputValues.branchId}
                                        type="text" name="branchId" onChange={handleChange} required /> */}

                                    <SearchableDropdown
                                        options={branchData}
                                        value={inputValues.branchId}
                                        onChange={(id) => setInputValues({ ...inputValues, branchId: id })}
                                        labelField="branchName"
                                        valueField="id"
                                        placeholder="Select Branch"
                                        required
                                    />
                                    {/* <label class="modify_p_text2">Branch Id</label> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="company_control">
                        {/* <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" required />
                                    <label class="modify_p_text2"> Id</label>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="date" name="" required />
                                    <label class="modify_lbl_text3">Creation Date</label>
                                </div>
                            </div>
                        </div> */}
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <select className="modify_im_input mode_category1"
                                        type="text" name="active" value={inputValues.active} onChange={handleChange} required >
                                        <option value={true}>Active</option>
                                        <option value={false}>Inactive</option>
                                    </select>
                                    <label class="modify_lbl_text3">Status</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="company_control">

                    </div>
                    <div className="ButtonTabSave">

                        {
                            itemId ? (

                                <button
                                    id="SaveBtnMain"
                                    className={`update-button-main-save hovered`}
                                    onClick={handleUpdate}
                                >
                                    Update
                                </button>
                            ) : (
                                <button
                                    id="SaveBtnMain"
                                    className={`save-button-main-save hovered`}
                                    onClick={handleSave}
                                >
                                    Save
                                </button>
                            )
                        }
                    </div>
                    <div className="company_info-text-im depart_top">Account Manager Information List</div>
                    <div className="control_radius">
                        <div className="table-account-manager">
                            <table className='table-master-acc'>
                                <thead className='header-table-account'>
                                    <tr>
                                        <th className='table-header-manager'>S.No</th>
                                        {/* <th className='table-header-manager'>Id</th> */}
                                        <th className='table-header-manager'>Branch Name</th>
                                        <th className='table-header-manager'>Account Manager</th>
                                        <th className='table-header-manager'>Creation Date</th>
                                        <th className='table-header-manager'>Status</th>
                                        <th className='table-header-manager'>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, idx) => (
                                        <tr key={item.id}>
                                            <td className='table-data-account ac-sno-wth'>{idx + 1}</td>
                                            {/* <td className='table-data-account'>{item.id}</td> */}
                                            <td className='table-data-account'>{getBranchName(item.branchId)}</td>
                                            <td className='table-data-account'>{getManagerName(item.acManagerId)}</td>
                                            <td className='table-data-account'>{formatIsoDate(item.creationDate)}</td>
                                            <td className='table-data-account'>{item.active ? "Active" : "Inactive"}</td>
                                            <td className='table-data-account'>
                                                <button className="edit-btn-acc" onClick={() => handleEdit(item)}>
                                                    <Icon icon="lucide:edit" />
                                                </button>
                                                <button className="delete-btn-acc" onClick={() => handleDelete(item.id)}>
                                                    <Icon icon="material-symbols:delete" />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AccountManageInformation;
